export const SET_PUBLISH_BAR_DISPLAY = 'SET_PUBLISH_BAR_DISPLAY';
export const SET_PUBLISH_ID = 'SET_PUBLISH_ID';
export const GET_PUBLISH_STATUS = 'GET_PUBLISH_STATUS';
export const SET_PUBLISH_STATUS = 'SET_PUBLISH_STATUS';
